module.exports = __webpack_public_path__ + "static/img/MRtu1@2x.21523e57.png";